// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2Evaj","filesListContainer":"PosDisputesFiles_filesListContainer__2RXYa","filesButton":"PosDisputesFiles_filesButton__1tuvQ"};